import { render, staticRenderFns } from "./mail-tags-modal.vue?vue&type=template&id=0a400164&scoped=true&"
import script from "./mail-tags-modal.vue?vue&type=script&lang=js&"
export * from "./mail-tags-modal.vue?vue&type=script&lang=js&"
import style0 from "./mail-tags-modal.vue?vue&type=style&index=0&id=0a400164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a400164",
  null
  
)

export default component.exports